module.exports = require("vfile-reporter");


//////////////////
// WEBPACK FOOTER
// external "vfile-reporter"
// module id = 44
// module chunks = 0 1 2 3 4 5 6 7 8 9 12 13